// @ts-nocheck
import LexendLight from 'assets/fonts/lexend-v19-latin-300.ttf';
import LexendMedium from 'assets/fonts/lexend-v19-latin-500.ttf';
import LexendSemiBold from 'assets/fonts/lexend-v19-latin-600.ttf';
import LexendBold from 'assets/fonts/lexend-v19-latin-700.ttf';
import LexendRegular from 'assets/fonts/lexend-v19-latin-regular.ttf';

export const Noto = {
  family: 'Noto',
  fallback: true,
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyCjA99d41P6zHtY.ttf',
      fontWeight: 300,
    },
    {
      src: 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyDPA99d41P6zHtY.ttf',
      fontWeight: 500,
    },
    {
      src: 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyAjBN9d41P6zHtY.ttf',
      fontWeight: 600,
    },
    {
      src: 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyAaBN9d41P6zHtY.ttf',
      fontWeight: 700,
    },
  ],
};

export const Lexend = {
  family: 'Lexend',
  fonts: [
    {
      src: LexendLight,
      fontWeight: 300,
    },
    {
      src: LexendRegular,
      fontWeight: 400,
    },
    {
      src: LexendMedium,
      fontWeight: 500,
    },
    {
      src: LexendSemiBold,
      fontWeight: 600,
    },
    {
      src: LexendBold,
      fontWeight: 700,
    },
  ],
};
